module.exports = require('./countries-loader.js!./countries.csv');
